import { FC, useCallback, useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import { DateRangePicker } from "@/components/common/date-range-picker/DateRangePicker";
import { Dates, NullableDates } from "@/services/cloudchipr.api";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { dashboardDatesByDashboardIdSelector } from "@/store/dashboards/selectors/dashboard/filters/dashboardDatesByDashboardIdSelector";
import { updateDashboardDateThunk } from "@/store/dashboards/thunks/dashboard/updateDashboardDateThunk";
import { currentDashboardProtectedSelector } from "@/store/dashboards/selectors/dashboard-hierarchy-visibility/currentDashboardProtectedSelector";

interface DashboardDatesProps {
  dashboardId: string;
}

export const DashboardDates: FC<DashboardDatesProps> = ({ dashboardId }) => {
  const dispatch = useAppDispatch();
  const [dates, setDates] = useState<NullableDates>(null);
  const dashboardDates = useAppSelector((state) =>
    dashboardDatesByDashboardIdSelector(state, dashboardId),
  );
  const isProtected = useAppSelector(currentDashboardProtectedSelector);

  const dateChangeHandler = useCallback(
    (newDates: Dates) => {
      setDates(newDates);

      dispatch(
        updateDashboardDateThunk({
          dates: newDates,
          dashboardId,
        }),
      );
    },
    [dashboardId, dispatch],
  );

  useEffect(() => {
    setDates(dashboardDates);
  }, [dashboardDates]);

  return (
    <Tooltip
      arrow
      placement="right"
      title={isProtected ? "Protected dashboards cannot be modified." : ""}
    >
      <span>
        <DateRangePicker
          highlightToday
          size="xsmall"
          disabled={isProtected}
          selectedDates={dates ?? {}}
          onDateSelect={dateChangeHandler}
        />
      </span>
    </Tooltip>
  );
};
